<template>
  <img v-if="feature.slug === 'face-swap' && modern" src="@/images/feature_icons/face-swap.jpg" :alt="feature.name" />
  <img v-else-if="feature.slug === 'face-swap'" src="@/images/feature_icons/face-swap.png" :alt="feature.name" />
  <img
    v-else-if="feature.slug === 'upscale-and-enhance-image' && modern"
    src="@/images/feature_icons/upscale-and-enhance-image.jpg"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'upscale-and-enhance-image'"
    src="@/images/feature_icons/upscale-and-enhance-image.png"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'restore-old-photo' && modern"
    src="@/images/feature_icons/restore-old-photo.jpg"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'restore-old-photo'"
    src="@/images/feature_icons/restore-old-photo.png"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'colorize-black-and-white-photo' && modern"
    src="@/images/feature_icons/colorize-black-and-white-photo.jpg"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'colorize-black-and-white-photo'"
    src="@/images/feature_icons/colorize-black-and-white-photo.png"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'remove-background' && modern"
    src="@/images/feature_icons/remove-background.jpg"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'remove-background'"
    src="@/images/feature_icons/remove-background.png"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'blur-background' && modern"
    src="@/images/feature_icons/blur-background.jpg"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'blur-background'"
    src="@/images/feature_icons/blur-background.png"
    :alt="feature.name"
  />
  <img v-else-if="feature.slug === 'blur-face'" src="@/images/feature_icons/blur-face.png" :alt="feature.name" />
  <img
    v-else-if="feature.slug === 'trim-transparent-pixels'"
    src="@/images/feature_icons/trim-transparent-pixels.png"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'image-shadow-generator'"
    src="@/images/feature_icons/image-shadow-generator.png"
    :alt="feature.name"
  />
  <img
    v-else-if="feature.slug === 'compress-image'"
    src="@/images/feature_icons/compress-image.png"
    :alt="feature.name"
  />
  <img v-else-if="feature.slug === 'crop-image'" src="@/images/feature_icons/crop-image.png" :alt="feature.name" />
  <img v-else-if="feature.slug === 'resize-image'" src="@/images/feature_icons/resize-image.png" :alt="feature.name" />
  <img
    v-else-if="feature.slug === 'convert-image'"
    src="@/images/feature_icons/convert-image.png"
    :alt="feature.name"
  />
  <img v-else-if="feature.slug === 'rotate-image'" src="@/images/feature_icons/rotate-image.png" :alt="feature.name" />

  <img
    v-else-if="feature.slug === 'photo-to-anime-converter'"
    src="@/images/feature_icons/photo-to-anime-converter.png"
    :alt="feature.name"
  />
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      feature: object
      modern?: boolean
    }>(),
    {
      modern: false,
    },
  )
</script>
